var render, staticRenderFns
import script from "./BasicCURDMixin.vue?vue&type=script&lang=js&"
export * from "./BasicCURDMixin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/iy_web_test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c74a3e8')) {
      api.createRecord('4c74a3e8', component.options)
    } else {
      api.reload('4c74a3e8', component.options)
    }
    
  }
}
component.options.__file = "src/components/Mixins/BasicCURDMixin.vue"
export default component.exports